import { render, staticRenderFns } from "./DefaultBackground.vue?vue&type=template&id=7ddbb442&scoped=true&"
import script from "./DefaultBackground.vue?vue&type=script&lang=js&"
export * from "./DefaultBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddbb442",
  null
  
)

export default component.exports